// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"Parent_rootContainer__1cstV"};